export class cpib2GatewaySpareParts{
    gatewayMacAddress: string;
    gatewayType: string;
    simCardIccId1: string;
    simCardIccId2: string;
    password: string;    
}